import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasketLineItemPOSDiscount',
  props: {
    disabled: { type: Boolean },
    initialDiscount: null
  },
  emits: ["change"],
  setup(__props: any, { emit }: { emit: ({(e: 'change', discount: string): void}), expose: any, slots: any, attrs: any }) {

const props = __props as {disabled: boolean, initialDiscount: string}




const discount = ref<string>(props.initialDiscount);

function onChange() {
    emit('change', discount.value);
}

return { __sfc: true,props, emit, discount, onChange }
}

})